import React, { useState, useEffect, useCallback } from "react";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import {
  Form,
  Button,
  Segment,
  Grid,
  Image,
  Header,
  Modal,
  Dimmer,
  Loader,

} from "semantic-ui-react";
import APIService from "../../Services/API/APIService";
import ReactDatePicker from "react-datepicker";
import numeral from "numeral";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import Checkout from "../Checkout/Checkout";
import moment from "moment";
const CreateBooking = (props) => {
  const [loading, setLoading] = useState(false);
  const [checkoutModalState, toggleCheckoutModal] = useState(null);
  const [selectedPackage, setSelectedPackage] = useState('1');
  const [packageType, setPackage] = useState([]);
  const [bookedDays, setBookedDays] = useState([])
  const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
  const schema = Yup.object().shape({
    checkin: Yup.date().required('Required'),
    checkout: Yup.date().required("Required"),
    firstname: Yup.string().required("Required"),
    lastname: Yup.string().required("Required"),
    name: Yup.string().required("Required"),
    email: Yup.string().email().required("Required"),
    phoneNumber: Yup.string().required('Required').matches(phoneRegExp, 'Phone number is not valid').test('len', 'Must be between 11 to 13 characters',
      val => !val || (val && val.toString().length >= 11 && val.toString().length < 13)),

  });



  const getPackage = useCallback( async (isSubscribed) => {
    try {
      let result = await APIService.getData('/guest-house/getPackages')
      if (isSubscribed) {

        setPackage(result)
      }

      let response = await APIService.getData('/guest-house/getBookedDays', {
        room: selectedPackage
      })
      if (isSubscribed) {

        setBookedDays(response)
      }

    } catch (error) {
      console.log(error);
    }

  },[selectedPackage])

  useEffect(() => {
    let isSubscribed = true;

    getPackage(isSubscribed)
    return () => (isSubscribed = false);
  }, [selectedPackage, getPackage]);
  const filterDate = date => {
    for (const day of bookedDays) {
      if (moment(date).isSame(day)) { return false; }
    }
    return true;
  };


  const checkForDateClash = (startDate, endDate) => {
    try {
      for (const bookedDay of bookedDays) {

        if (
          moment(bookedDay).isBetween(startDate, endDate, 'days', '[]')
        ) {

          return true; //date clash
        }
      }

      return false;
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  const _saveBooking = async (values) => {
    // console.log("values", values);
    try {
      let clash = checkForDateClash(
        values.checkin,
        values.checkout,
      );

      if (clash) {
        toast.warning(
          "Date clash: selected cannot dates can't overlapped with unavilable dates"
        );
        return;
      }
      setLoading(true);
      let nights = dayjs(values.checkout).diff(values.checkin, "day");
      let cartId = null
      if (cartId) {
        await APIService.postData("/checkout/clearCurrentCartGuestHouse", {
          email: values.email,
          cartId: cartId

        })
      }

      let payload = {
        Id: selectedPackage,
        checkin: values.checkin,
        checkout: values.checkout,
        nights: nights,
        email: values.email,
        firstname: values.firstname,
        lastname: values.lastname,
        phone: values.phoneNumber,
        price: packageArray[0]?.price,
        roomName: packageArray[0]?.name

      };

      let response = await APIService.postData("/checkout/addGuestHouseCart", payload);

      localStorage.setItem('cartId', response.cartId)
      localStorage.setItem('payload', JSON.stringify(payload))
      setLoading(false);

      if (response) {
        toggleCheckoutModal(true);
      }


    } catch (error) {
      console.log("error", error);
    }
  };

  let packageArray = packageType.filter(item => item.roomCode === selectedPackage)
  const image = packageArray[0]?.GuestHouseGalleries[0]?.resizeLocation

  return (
    <div>
      {loading && (
        <Dimmer active inverted>
          <Loader />
        </Dimmer>
      )}
      <Segment textAlign="left">
        <Grid columns="2" stackable>
          <Grid.Row>
            <Grid.Column>
              {/* {JSON.stringify(bookedDays,null,2)} */}
              <Image
                src={image}
                style={{ height: 300 }}
              />
            </Grid.Column>
            <Grid.Column>

              <Formik
                enableReinitialize={true}
                initialValues={{

                  checkin: "",
                  checkout: "",
                  firstname: '',
                  lastname: '',
                  name: '',
                  email: '',
                  phoneNumber: ''
                }}
                validationSchema={schema}
                onSubmit={_saveBooking}
              >
                {(props) => {
                  const {
                    values,
                    touched,
                    errors,
                    handleChange,
                    handleSubmit,
                  } = props;
                  return (
                    <Form onSubmit={handleSubmit}>
                      <Form.Field error={touched.name && errors.name}   >
                        <label>Package</label>
                        <Field
                          as="select"
                          name="name"
                          value={values.name || ""}
                          onChange={(value) => {

                            value.persist();
                            let item = value.target.value;
                            props.setFieldValue("name", item);

                            setSelectedPackage(item);
                          }}

                        >
                          <option value="" disabled defaultValue hidden>
                            Select Package
                          </option>
                          {packageType?.map((item) => (
                            <option key={item.roomCode} value={item.roomCode}>
                              {item.name}
                            </option>
                          ))}
                        </Field>
                      </Form.Field>
                      <Header>{packageArray[0]?.name}</Header>
                      <Header size="small">
                        ₦{numeral(packageArray[0]?.price).format("0,0")}
                      </Header>


                      <Form.Group widths={2}>
                        <Form.Input

                          placeholder="First Name"
                          name="firstname"
                          value={values.firstname}
                          onChange={handleChange}
                          error={touched.firstname && errors.firstname}
                        />
                        <Form.Input

                          placeholder="Last Name"
                          name="lastname"
                          value={values.lastname}
                          onChange={handleChange}
                          error={touched.lastname && errors.lastname}
                        />
                      </Form.Group>

                      <Form.Group widths={2} >
                        <Form.Input

                          placeholder="Customer Email"
                          name="email"

                          value={values.email}
                          onChange={handleChange}
                          error={touched.email && errors.email}
                        />

                        <Form.Input


                          placeholder="Customer Phone"
                          name="phoneNumber"
                          value={values.phoneNumber}
                          onChange={handleChange}
                          error={touched.phoneNumber && errors.phoneNumber}
                        />
                      </Form.Group>



                      <Form.Group widths={2}>
                        <Form.Input
                          control={ReactDatePicker}
                          placeholderText="Select a date"
                          minDate={dayjs().toDate()}
                          maxDate={dayjs().add(3, "month").toDate()}

                          label="Check-in Date"
                          filterDate={filterDate}
                          selected={
                            values.checkin
                              ? dayjs(values.checkin).toDate()
                              : ""
                          }
                          onChange={(value) => {
                            props.setFieldValue("checkin", value);
                          }}
                          error={touched.checkin && errors.checkin}
                        />

                        <Form.Input
                          control={ReactDatePicker}
                          disabled={!values.checkin}
                          placeholderText="Check-out  a date"
                          minDate={dayjs(values.checkin).add(1, "day").toDate()}

                          label="Check-out Date"
                          filterDate={filterDate}
                          selected={
                            values.checkout
                              ? dayjs(values.checkout).toDate()
                              : ""
                          }
                          onChange={(value) => {
                            props.setFieldValue("checkout", value);
                          }}
                          error={touched.checkout && errors.checkout}
                        />
                      </Form.Group>

                      <Button type='submit' style={{ backgroundColor: '#26f09e', color: '#000000' }} content="Book Now" />
                    </Form>
                  );
                }}
              </Formik>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>


      <Modal
        size="small"
        open={checkoutModalState}
        onClose={() => {
          toggleCheckoutModal(false);
        }}
        closeIcon
      >
        <Modal.Header>Payment</Modal.Header>
        <Modal.Content>
          <Checkout toggleModal={toggleCheckoutModal} />
        </Modal.Content>
      </Modal>
    </div>
  );
};

export default CreateBooking;
